import React from 'react';
import './Hero.scss';
import { usePageBackground } from '../../lib/cmsUtils';
import defaultHero from '../../assets/main.svg';

const Hero = () => {
  const bgImage = usePageBackground('home', defaultHero);

  return (
    <section className="hero" style={{ backgroundImage: `url(${bgImage})` }}>
      <div className="hero-content">
        <h1>International <br/>Innovation & Creative Industries Cluster</h1>
        <button className="btn">
          <a href="https://docs.google.com/forms/d/e/1FAIpQLSdmV5pE7M7KYsxvEPHdt9xHGZgodzY4s3neDfVa4sfgKczd_Q/viewform" target="_blank" rel="noreferrer">
            Become our member
          </a>
        </button>
      </div>
    </section>
  );
};

export default Hero;
